import { render, staticRenderFns } from "./FragebogenVersendenPopup.vue?vue&type=template&id=651430a0&scoped=true&"
import script from "./FragebogenVersendenPopup.vue?vue&type=script&lang=js&"
export * from "./FragebogenVersendenPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651430a0",
  null
  
)

export default component.exports